export const STATIC_TRANSLATIONS = {
  termsInfo: {
    contact_us: 'static.termsInfo.contact_us',
    privacy_policy: 'static.termsInfo.privacy_policy',
    terms: 'static.termsInfo.terms',
    billing_terms: 'static.termsInfo.billing_terms',
    money_back: 'static.termsInfo.money_back',
  },
  subsFAQ: {
    title: 'static.subsFAQ.title'
  },
  subsReviews: {
    title: 'static.subsReviews.title'
  },
  subsFooter: {
    appName: 'static.subsFooter.appName',
    allRightsReserved: 'static.subsFooter.allRightsReserved'
  },
  genders: {
    female: 'static.genders.female',
    male: 'static.genders.male',
    binary: 'static.genders.binary'
  },
  buttons: {
    default: 'static.buttons.default'
  },
  successPage: {
    wait: 'static.successPage.wait'
  },
  paymentPopup: {
    moneyBack: "static.paymentPopup.moneyBack",
    editEmail: {
      label: "static.paymentPopup.editEmail.label",
      error: {
        length: "static.paymentPopup.editEmail.error.length",
        invalid: "static.paymentPopup.editEmail.error.invalid"
      },
      title: "static.paymentPopup.editEmail.title",
      placeholder: "static.paymentPopup.editEmail.placeholder",
      button: "static.paymentPopup.editEmail.button"
    },
    or: "static.paymentPopup.or",
    payWithCard: "static.paymentPopup.payWithCard",
    cardElementRecurly: {
      cardNumber: "static.paymentPopup.cardElementRecurly.cardNumber",
      mm: "static.paymentPopup.cardElementRecurly.mm",
      yy: "static.paymentPopup.cardElementRecurly.yy",
      firstName: "static.paymentPopup.cardElementRecurly.firstName",
      lastName: "static.paymentPopup.cardElementRecurly.lastName"
    },
    cardElementTruegate: {
      cardNumber: "static.paymentPopup.cardElementTruegate.cardNumber",
      date: "static.paymentPopup.cardElementTruegate.date",
      cvv: "static.paymentPopup.cardElementTruegate.cvv",
      name: "static.paymentPopup.cardElementTruegate.name"
    },
    discountTimer: "static.paymentPopup.discountTimer",
  },
  errorPopup: {
    title: "static.errorPopup.title",
    text: "static.errorPopup.text",
    button: "static.errorPopup.button",
    buttonLater: "static.errorPopup.buttonLater"
  },
  unit: {
    ft: 'static.unit.ft',
    in: 'static.unit.in',
    cm: 'static.unit.cm',
    mm: 'static.unit.mm',
    lbs: 'static.unit.lbs',
    oz: 'static.unit.oz',
    kg: 'static.unit.kg',
    g: 'static.unit.g',
  },
  error: {
    inputUnit: "static.error.inputUnit",
  },
  pickAnswers: "static.pickAnswers"
}

